export default {
  mode: {
    light: "Light",
    dark: "Dark"
  },
  
  guide: {
    title: "Theme Guide"
  },
  
  colors: {
    title: "Colors",
    primary500: "Primary 500",
    primary600: "Primary 600", 
    primary700: "Primary 700",
    secondary500: "Secondary 500",
    success: "Success",
    warning: "Warning",
    error: "Error",
    background: "Background",
    surface: "Surface",
    card: "Card"
  },
  
  typography: {
    title: "Typography",
    h1: "Heading 1",
    h1Font: "Text 4xl Serif",
    h2: "Heading 2", 
    h2Font: "Text 3xl Serif",
    h3: "Heading 3",
    h3Font: "Text 2xl Serif",
    body: "Body text",
    bodyFont: "Text base",
    small: "Small text",
    smallFont: "Text sm"
  },
  
  components: {
    title: "Components",
    
    buttons: {
      title: "Buttons",
      default: "Default",
      outline: "Outline",
      secondary: "Secondary", 
      ghost: "Ghost",
      danger: "Danger",
      success: "Success",
      disabled: "Disabled",
      loading: "Loading"
    },
    
    form: {
      title: "Form Elements",
      input: "Input Field",
      select: "Select Field",
      switch: "Switch"
    },
    
    badges: {
      title: "Badges",
      default: "Default",
      secondary: "Secondary",
      success: "Success",
      warning: "Warning",
      error: "Error",
      mint: "Mint",
      rose: "Rose",
      outline: "Outline"
    },
    
    alerts: {
      title: "Alerts",
      info: {
        title: "Information",
        description: "This is an informational alert."
      },
      success: {
        title: "Success",
        description: "This is a success alert."
      },
      warning: {
        title: "Warning", 
        description: "This is a warning alert."
      },
      error: {
        title: "Error",
        description: "This is an error alert."
      }
    }
  },
  
  code: {
    title: "Code Examples",
    darkMode: {
      title: "Dark Mode Implementation",
      example: "className=\"bg-white dark:bg-dark-card text-gray-900 dark:text-white\""
    }
  }
} 